import { assignedResource } from '@townsquare/assigned/resource';
import { SkeletonWithoutBreadcrumbs } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { yourWorkRouteDefinition } from '@townsquare/routes/your-work';
import { platformStarredFeedResource } from '@townsquare/starred-feed/resource';
import { LoadingState } from '@townsquare/your-work/loading-state';

yourWorkRouteDefinition.component = Loadable({
	loader: () =>
		import(/* webpackChunkName: "your-work-view" */ './components/YourWorkView').then(
			({ YourWorkView }) => YourWorkView,
		),
	loading: LoadingState,
});

yourWorkRouteDefinition.header = Loadable({
	loader: () =>
		import(/* webpackChunkName: "your-work-header" */ './components/YourWorkHeader').then(
			({ YourWorkHeader }) => YourWorkHeader,
		),
	loading: SkeletonWithoutBreadcrumbs,
});

yourWorkRouteDefinition.resources = [assignedResource, platformStarredFeedResource];

export const yourWorkRoute: GlobalHomePageRoute = yourWorkRouteDefinition;
